module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ded"
  }, [_c('span', [_c('i', [_vm._v("There are many invincible, intelligent women in this world who, like Elizabeth Sterling, have survived terrible adversity with both their")])])]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_c('span', [_c('i', [_vm._v("dignity and femininity intact")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_c('span', [_c('i', [_vm._v("This work is dedicated to two of them:")])])]), _vm._v(" "), _c('p', {
    staticClass: "ded2"
  }, [_c('span', [_c('i', [_vm._v("Patricia Ann Davenport")]), _vm._v(",")])]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_c('span', [_c('i', [_vm._v("my long-time business partner and executive assistant")]), _vm._v(",")])]), _vm._v(" "), _c('p', {
    staticClass: "ded2"
  }, [_c('span', [_c('i', [_vm._v("and")])])]), _vm._v(" "), _c('p', {
    staticClass: "ded2"
  }, [_c('span', [_c('i', [_vm._v("Mary Carolyn Carmichael")]), _vm._v(",")])]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_c('span', [_c('i', [_vm._v("my sister, and a fellow Texas lawyer")]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cb6c9d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/dedication.vue
// module id = 72
// module chunks = 0